export type LoadStatusName = "idle" | "loading" | "succeeded" | "failed";

export interface LoadStatus {
  status: LoadStatusName;
  loadedAt?: number;
  error?: string;
}

export const idleLoadStatus: LoadStatus = { status: "idle" };

export function shouldFetch(status?: LoadStatus, force = false): boolean {
  if (force) {
    return status?.status !== "loading";
  }
  return !status || status.status === "idle" || status.status === "failed";
}

export function loadingStatus(): LoadStatus {
  return { status: "loading" };
}

export function succeededStatus(loadedAt = Date.now()): LoadStatus {
  return { status: "succeeded", loadedAt };
}

export function failedStatus(error: unknown): LoadStatus {
  return {
    status: "failed",
    error: error instanceof Error ? error.message : `${error}`,
  };
}
